function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);














class CarouselComponent extends HTMLElement {
constructor() {
super();

this.slideBox = this.querySelector('.carouselBox');
this.slides = this.querySelectorAll('.carouselSlider');
this.slideLot = this.querySelector('.activeNumber');

this.prevBtn = this.querySelector("#prevSlide");
this.nextBtn = this.querySelector("#nextSlide");
this.pausePlay = this.querySelector(".pauseContainer");
this.slideDots = this.querySelectorAll('.slideDots');

this.counter = this.dataset.counterType;
this.interval = this.dataset.interval;
this.infinite = this.dataset.infiniteScroll;
this.autoplay = this.dataset.autoplay;

if(!this.slideDots) return;
this.slideDots.forEach( dot => dot.addEventListener('click', this.showDot.bind(this)));
this.timeout;
this.curSlide = 0;

if(this.autoplay == 'true') {
this.autoPlayFx();
this.infinite = 'true';
}else {
clearInterval(this.autoplaying);
this.infinite = 'false';
}

this.init()
const resizeObserver = new ResizeObserver(entries => this.init());
resizeObserver.observe(this.slideBox);

this.prevBtn.addEventListener("click", this.prevFx.bind(this));
this.nextBtn.addEventListener("click", this.nextFx.bind(this));
if(!this.pausePlay) return;
this.pausePlay.addEventListener("click", this.pauseFx.bind(this));
}

init() {
if (this.counter == 'number') {
this.slideLot.innerHTML = 1;
}
this.goToSlide(0);
}

autoPlayFx(){
clearInterval(this.autoplaying);
this.autoplaying = setInterval(this.nextFx.bind(this), this.interval);
}

pauseFx() {
this.pauseBtn = this.pausePlay.querySelector('.pauseBtn');
this.playBtn = this.pausePlay.querySelector('.playBtn');
if (this.autoplay === 'true'){
clearInterval(this.autoplaying);
this.autoplay = 'false';

this.playBtn.style.display = "block";
this.pauseBtn.style.display = "none";
}else{
if(this.curSlide == this.slides.length -1) {
this.curSlide = -1;
}
this.autoPlayFx();
this.autoplay = 'true';
this.playBtn.style.display = "none";
this.pauseBtn.style.display = "block";
}
}

prevFx () {
this.curSlide--;
if(this.curSlide < 0){
if(this.infinite == 'true') {
this.curSlide = this.slides.length - 1;
} else {
this.curSlide = 0;
}
}
this.goToSlide(this.curSlide );
this.activeSlide(this.curSlide );
}

nextFx () {
this.curSlide ++
if(this.curSlide == this.slides.length) {
if(this.infinite == 'true') {
this.curSlide = 0;
}
if(this.autoplay == 'true') {
this.curSlide = 0;
}
}
this.goToSlide(this.curSlide );
this.activeSlide(this.curSlide );
}

showDot(e) {
if(!e.currentTarget) return;
const currentDot = e.currentTarget.dataset.dotId;

this.activeSlide(currentDot);
}

goToSlide (slide) {
let leftScroll = slide * this.slides[0].clientWidth;
this.slideBox.scrollTo({left: leftScroll});
}

activeSlide(currentDot) {
this.slideDots.forEach(dot => dot.classList.remove('activeDot'));

if(this.infinite == 'false') {
if(currentDot == this.slides.length - 1) {
this.nextBtn.setAttribute('disabled', true);
} else {
this.nextBtn.removeAttribute('disabled');
}
if(currentDot == 0) {
this.prevBtn.setAttribute('disabled', true);
} else {
this.prevBtn.removeAttribute('disabled');
}
}

this.slideLot.innerHTML = currentDot + 1;
if(! this.slideDots[currentDot]) return;
this.slideDots[currentDot].classList.add('activeDot');
this.showDot(currentDot);

this.curSlide = currentDot;
this.goToSlide(currentDot );
}
}

customElements.define('carousel-component', CarouselComponent);

















class TestimonialSlider extends HTMLElement {
constructor() {
super();
this.sliderControlWrapper = this.querySelector('.slider-buttons');

this.slider = this.querySelector('[data-slider]');
this.sliderItems = this.querySelectorAll('[data-slider-item]');

this.sliderControlLinksArray = Array.from(this.querySelectorAll('[data-counter]'));
this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));

this.slider.addEventListener('scroll', this.scrollListener.bind(this));
}

scrollListener() {
this.sliderItemOffset = this.sliderItems[1].offsetLeft - this.sliderItems[0].offsetLeft;
this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

this.currentIndex(this.currentPage - 1);
}

update(slide) {
this.currentIndex(slide);
this.slideScrollPosition = slide * this.sliderItems[0].clientWidth;

this.slider.scrollTo({
left: this.slideScrollPosition
});
}

linkToSlide(event) {
const dotIndex = event.currentTarget.dataset.counter;
this.step = dotIndex;
this.update(this.step);
}

currentIndex(index) {
this.sliderControlLinksArray.forEach(link => {
link.classList.remove('slide__link--active');
link.removeAttribute('aria-current');
});

this.sliderControlLinksArray[index].classList.add('slide__link--active');
this.sliderControlLinksArray[index].setAttribute('aria-current', true);

this.sliderItems.forEach(slide => {
slide.classList.remove('slide--active');
slide.removeAttribute('aria-current');
});

this.sliderItems[index].classList.add('slide--active');
this.sliderItems[index].setAttribute('aria-current', true);
}
}

customElements.define('testimonial-slider', TestimonialSlider);












class CustomSlideshow extends HTMLElement {
constructor() {
super();

this.autoplaySet = this.dataset.autoplay;
this.interval = this.dataset.interval;
this.slides = this.querySelectorAll(".slideWrapper");
this.img = this.querySelector(".slideImage");
this.prevBtn = this.querySelector("#prevBtn");
this.nextBtn = this.querySelector("#nextBtn");
this.pauseBtnContainer = this.querySelector("#pauseBtnContainer");
this.pauseBtn = this.querySelector(".pauseBtn");
this.playBtn = this.querySelector(".playBtn");
this.slideDots = this.querySelectorAll('.slideDots');
this.autoplay = this.autoplaySet;
this.index = 0;
this.prevBtn.addEventListener('click', this.prevFx.bind(this));
this.nextBtn.addEventListener('click', this.nextFx.bind(this));

this.slideDots.forEach((dot) => {dot.addEventListener('click', this.indexDot.bind(this))});
if(this.autoplaySet == 'true') {
this.pauseBtnContainer.classList.remove('hidden');
}else {
this.pauseBtnContainer.classList.add('hidden');
}
this.pauseBtnContainer.addEventListener('click', this.pauseFx.bind(this));
this.init();
}
init() {
this.goToSlide(this.index);
this.pauseFx();
}
nextFx() {
this.index++;
if (this.index > this.slides.length -1) {this.index = 0};
this.goToSlide(this.index);
this.showDot(this.index);
}
prevFx() {
this.index--;
if (this.index < 0) {this.index = this.slides.length -1};
this.goToSlide(this.index);
this.showDot(this.index);
}

pauseFx() {
if (this.autoplay == 'true'){
this.autoplay = 'false';
this.playBtn.style.display = "block";
this.pauseBtn.style.display = "none";
clearInterval(this.timeout);
this.timeout = setInterval(this.nextFx.bind(this), this.interval);
}else{
clearInterval(this.timeout);
this.autoplay = 'true';
this.playBtn.style.display = "none";
this.pauseBtn.style.display = "block";
}
}
indexDot(e) {
let target = e.currentTarget.dataset.dotId;
this.showDot(target);
this.index = target;
}
showDot(target) {
this.slideDots.forEach(dot => dot.classList.remove('activeDot'));
this.slideDots[target].classList.add('activeDot');
this.goToSlide(target);
}
goToSlide(index) {
this.slides.forEach((slide) => {slide.style.display = "none"});
this.slides[index].style.display = "block";
}
}

customElements.define('custom-slideshow', CustomSlideshow);












class CountdownSection extends HTMLElement {
constructor() {
super()
this.targetDate = new Date(this.dataset.date);
this.init();
}

init() {
const countdownTimer = setInterval(() => {
const isComplete = this.updateAllSegments();

if (isComplete) {
clearInterval(countdownTimer);
}
}, 1000);
}

updateSegmentValues(displayElement,overlayElement,value) {
displayElement.textContent = value;
overlayElement.textContent = value;
}

getTimeSegmentElements(segmentElement) {
const segmentDisplay = segmentElement.querySelector('.countdown-card');
const segmentDisplayTop = segmentDisplay.querySelector('.countdown-card__top');
const segmentDisplayBottom = segmentDisplay.querySelector('.countdown-card__bottom');

const segmentOverlay = segmentDisplay.querySelector('.countdown-overlay');
const segmentOverlayTop = segmentOverlay.querySelector('.countdown-overlay__top');
const segmentOverlayBottom = segmentOverlay.querySelector('.countdown-overlay__bottom');

return { segmentDisplayTop, segmentDisplayBottom, segmentOverlay, segmentOverlayTop, segmentOverlayBottom };
}

updateTimeSegment(segmentElement, timeValue) {
const segmentElements = this.getTimeSegmentElements(segmentElement);

if ( parseInt(segmentElements.segmentDisplayTop.textContent,10) === timeValue) {
return;
}

segmentElement.querySelector('.countdown-overlay').classList.add('flip');
this.updateSegmentValues(segmentElements.segmentDisplayTop, segmentElements.segmentOverlayBottom,timeValue);
segmentElements.segmentOverlay.addEventListener(
'animationend',
this.finishAnimation.bind(this, segmentElements, timeValue)
);
}

finishAnimation(segmentElements, timeValue) {
this.updateSegmentValues(segmentElements.segmentDisplayBottom,segmentElements.segmentOverlayTop, timeValue);
segmentElements.segmentOverlay.classList.remove('flip')
this.removeEventListener('animationend',this);
}

updateTimeSection(sectionID, timeValue) {
const firstNumber = Math.floor(timeValue / 10) || 0;
const secondNumber = timeValue % 10 || 0;
const sectionElement = document.getElementById(sectionID);
const timeSegments = sectionElement.querySelectorAll('.time-segment');

if(timeValue <= 0){
if(sectionID == "days" || sectionID == "hours") {
sectionElement.style.display = "none";
}
}

this.updateTimeSegment(timeSegments[0], firstNumber);
this.updateTimeSegment(timeSegments[1], secondNumber);
}


getTimeRemaining(targetDateTime) {
const nowTime = Date.now();
const complete = nowTime >= targetDateTime;

if (complete) {
return {complete, seconds: 0, minutes: 0, hours: 0, days: 0};
}

const secondsRemaining = Math.floor((targetDateTime - nowTime) / 1000);
const days = Math.floor(secondsRemaining / 86400) % 24;
const hours = Math.floor(secondsRemaining / 3600) % 24;
const minutes = Math.floor(secondsRemaining / 60) % 60;
const seconds = secondsRemaining % 60;

return {complete, seconds, minutes, hours, days};
}

updateAllSegments() {
const timeRemainingBits = this.getTimeRemaining(
new Date(this.targetDate).getTime()
);

this.updateTimeSection('seconds', timeRemainingBits.seconds);
this.updateTimeSection('minutes', timeRemainingBits.minutes);
this.updateTimeSection('hours', timeRemainingBits.hours);
this.updateTimeSection('days', timeRemainingBits.days);
return timeRemainingBits.complete;
}
}
customElements.define("countdown-section", CountdownSection);












class CarouselImage extends HTMLElement {
constructor() {
super()

this.prevButton = this.querySelector('button[name="previous"]');
this.nextButton = this.querySelector('button[name="next"]');
this.container = this.querySelector('ul');
this.images = this.querySelectorAll('li');
this.clickedImgContainer = this.querySelector('.carousel--clicked-image-container');
this.scaleImage = this.querySelector('.scale-image');
this.clickedImage = this.querySelector('.clicked--img');
this.closeBtns = this.querySelectorAll('.carousel--close-btn');

this.addEventListener("mousewheel", this.wheelListener.bind(this), {passive: false});
this.addEventListener("DOMMouseScroll", this.wheelListener.bind(this), {passive: false});
this.addEventListener("wheel", this.wheelListener.bind(this), {passive: false})

if(this.prevButton){
this.prevButton.addEventListener('click', this.buttonListener.bind(this));
this.nextButton.addEventListener('click', this.buttonListener.bind(this));
}

if(this.clickedImgContainer) {
this.closeBtns.forEach(btn => btn.addEventListener('click', this.closeImage.bind(this)));
document.addEventListener('keydown', this.keydownListener.bind(this));
}

this.images.forEach(img => img.addEventListener('click', this.openImage.bind(this)));

const resizeObserver = new ResizeObserver(entries => this.init());
resizeObserver.observe(this.container);
this.num = 2;
this.init();
}

init(){
const boxWidth = screen.width / 2;
const firstImg = this.images[1].clientWidth / 2;
const lastImg = this.images[this.images.length - 1].clientWidth / 2
const assignedFirstWidth = (boxWidth - firstImg);
const assignedLastWidth = (boxWidth - lastImg);

this.firstImgWidth = Math.round(boxWidth - firstImg);
this.images[0].querySelector('img').style.width = assignedFirstWidth + "px";
this.images[this.images.length - 1].querySelector('img').style.width = assignedLastWidth + "px";

this.update(this.num)
}

update(num) {
this.clickedImage = this.querySelector('.clicked--img');
this.scaleImage = this.querySelector('.scale-image');
this.num = num;
}

closeImage(e) {
e.preventDefault();
this.clickedImgContainer.style.display = "none";
console.log('close', e.currentTarget)
this.num = e.currentTarget.parentElement.dataset.image;

this.findElement(this.num);
}

openImage(e) {
e.preventDefault();
const num = e.currentTarget.dataset.slide;

if(e.currentTarget.classList.contains('scale-image')) {
this.clickedImgContainer.style.display = "flex";
this.openClickedImage(num);
} else {
this.findElement(num)
}

this.update(num)
}

keydownListener(e) {
const key = e.key;
let num = this.querySelector('.clicked--img').dataset.image
if(key == 'ArrowRight' ) {
num < this.images.length - 1 ? num++ : num = 2
}

if(key == 'ArrowLeft' ) {
num > 2 ? num-- : num = this.images.length - 1
}

this.openClickedImage(num);
}

openClickedImage(num) {
console.log('click')
this.querySelectorAll('.carousel--clicked-image').forEach(img=> img.classList.remove('clicked--img'))
this.querySelector(`[data-image="${num}"]`).classList.add('clicked--img');
this.update(num)
}

wheelListener(e) {
e.preventDefault();
if(e.deltaY > 1) {
if(this.num < this.images.length - 1) this.num++
} else {
if(this.num > 2) this.num--
}

this.findElement(this.num)
}

buttonListener(e) {
e.preventDefault();
if(e.currentTarget.name == 'next' ) {
if(this.num < this.images.length - 1) {
this.num++;
}
}else {
if(this.num > 2) {
this.num--;
}
}
this.findElement(this.num)
}

findElement(num) {
if(this.prevButton) {
num == this.images.length - 1 ? this.nextButton.disabled = true : this.nextButton.disabled = false
num == 2 ? this.prevButton.disabled = true : this.prevButton.disabled = false
}

this.images.forEach(img => {img.classList.remove('scale-image')})
const el = this.querySelector(`[data-slide="${num}"]`);

if(el) {
el.classList.add('scale-image')
const el_middle_width = el.clientWidth / 2;
const middle_width = this.container.clientWidth / 2;
let containerScrollX = (el.offsetLeft + el_middle_width ) - middle_width;
if (containerScrollX < 0) containerScrollX = 0;

this.container.scrollLeft = containerScrollX;
}

this.update(num)
}
}
customElements.define("carousel-image", CarouselImage);


